
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.css'],
})

export class VideoDialogComponent implements OnInit {
  public trustedUrl: SafeUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    if (this.data && (this.data.assetId || this.data.asset_id)) {
      const videoId = (this.data.assetId || this.data.asset_id).replace('video:', '');
      this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.dvidshub.net/video/embed/' + videoId);
    }
  }
}
